export const parsePrivilegedCompany = values => ({
  relatedCompany: values?.relatedCompany?.value || values,
  exceptionTypes: values?.exceptionTypes?.map(exceptionType => exceptionType.value),
});
